export default {
    landingURL: import.meta.env.VUE_APP_LANDING_URL,
    baseURL: import.meta.env.VUE_APP_URL,
    locale: 'en',
}
